<div>
  <div class="pure-menu pure-menu-horizontal">
    <a href="" onClick="return false;" class="pure-menu-heading pure-menu-link">Update validation Threshold for Auto Approval</a>
  </div>

  <div class="container">
    <!-- Fetch Previous Requests Form-->
    <form [formGroup]="updateValidationThresholdForm" [hidden]="loading" class="pure-form pure-form-stacked">

      <!-- Select option for From Country Code Options -->
      <div class="pure-control-group">
        <label for="fromCountryCodeId">From Country Code <app-popover [message]="help_messages.from_country_code"></app-popover></label>
        <select id="fromCountryCodeId" class="pure-input-2-3"
                formControlName="fromCountryCode" #fromCountryCode (change)="onFromCountryCodeChange(fromCountryCode.value)">
          <option *ngFor="let _fromCountryCode of fromCountryCodeOptions; let i = index"
                  [value]="_fromCountryCode">
            {{ _fromCountryCode }}
          </option>
        </select>
      </div>

      <div class="pure-control-group">
        <label for="businessUseCase">Business Use Case  <app-popover [message]="help_messages.business_unit"></app-popover></label>
        <select name="businessUseCase" id="businessUseCase" class="pure-input-2-3" formControlName="businessUseCase" #businessUseCaseRef (change)="onBusinessUseCaseChange(businessUseCaseRef.value)">
          <ng-template ngFor let-item [ngForOf]="getItems">
            <optgroup label="{{item.name}}">
              <option *ngFor="let usecase of item.usecases" [value]="usecase.value">
                {{usecase.text}}
              </option>
            </optgroup>
          </ng-template>
        </select>
      </div>

      <!-- Read only text for displaying onboarded component key placeholder-->
      <label for="componentKeyPlaceholderId">Level Of Data  <app-popover [message]="help_messages.level_of_data"></app-popover></label>
      <input id="componentKeyPlaceholderId" class="pure-input-2-3" type="text"
             formControlName="componentKeyPlaceholder" readonly/>

      <!-- Dynamic entries for Component Key Place holder parts -->
      <form [formGroup]="updateValidationThresholdForm.get('componentKeyValue')">
        <div *ngFor="let field of currentComponentKeyPlaceholder;let i = index">
          <label for="{{'componentKeyValue'+i}}">{{field}}</label>
          <select type="text" [formControlName]="field" class="pure-input-2-3" id="{{'componentKeyValue'+i}}">
            <option *ngFor="let option of dropDownOptions[field]" [value]="option" [disabled]="passportEnabledShipmethods[option]">
              {{option}}
            </option>
          </select>
        </div>
      </form>

      <!-- Select option for Transit Time Type-->
      <label for="transitTimeTypeId">Select Transit Time Type <app-popover [message]="help_messages.transit_time_type"></app-popover></label>
      <select formControlName="transitTimeType" id="transitTimeTypeId" class="pure-input-2-3">
        <option *ngFor=" let _transitTime of transitTimeOptions; let i = index " [value]="_transitTime">
          {{ _transitTime }}
        </option>
      </select>

      <!-- Get data Buttons-->
      <div>
        <button style="margin: 10px" class="pure-button pure-button-primary button-large" type="submit" [disabled]="updateValidationThresholdForm.invalid" (click)="onGetAllThresholds()">
          Get All Thresholds
        </button>
        <button style="float: inside; margin: 10px" class="pure-button pure-button-primary button-large" [disabled]="updateValidationThresholdForm.invalid" (click)="onAddThreshold()">
          Add Threshold
        </button>
      </div>
    </form>

    <br>
    <div *ngIf="transitTimeUpdateValidationThresholdList.length != 0 && !loading && hasPermission">
      <table class="pure-table pure-table-horizontal">
        <thead>
        <tr>
          <th>Cron Description</th>
          <th>Transit Time</th>
          <th>Threshold</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let _row of transitTimeUpdateValidationThresholdList">
          <td>
            {{ _row.cronDescriptor != null ? _row.cronDescriptor : "N/A"}}
          </td>
          <td>
            {{_row.transitTime != null ? (_row.transitTime != "*" ? _row.transitTime: "ALL") : "N/A"}}
          </td>
          <td>
            {{_row.threshold != null ? _row.threshold : "N/A"}}
          </td>
          <td>
            <button mat-fab color="red" aria-label="Example icon button with a delete icon" (click)="onEditThreshold(_row)" >
              <mat-icon >edit</mat-icon>
            </button>
            <button mat-fab color="red" aria-label="Example icon button with a delete icon" (click)="onDeleteThreshold(_row)" >
              <mat-icon >delete</mat-icon>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div>
      <!-- Display message when the table is empty -->
      <div *ngIf="transitTimeUpdateValidationThresholdList.length == 0 && !loading && !firstLoad && hasPermission">
        <h2>There are no thresholds configured.</h2>
      </div>
    </div>
    <div *ngIf="transitTimeUpdateValidationBaseThresholdList.length != 0 && !loading && hasPermission">
      <br>
      <hr>
      <br>
      <label> <b> BASE THRESHOLD </b><app-popover [message]="help_messages.baseThreshold"></app-popover></label>
      <table class="pure-table pure-table-horizontal" style="padding: 20px">
        <thead>
        <tr>
          <th>Transit Time</th>
          <th>Threshold</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let _row of transitTimeUpdateValidationBaseThresholdList">
          <td>
            {{_row.transitTime != null ? (_row.transitTime != "*" ? _row.transitTime: "ALL") : "N/A"}}
          </td>
          <td>
            {{_row.threshold != null ? _row.threshold : "N/A"}}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <app-loader [loading]="loading" [size]="'small'"></app-loader>
  </div>
</div>
